<script setup lang="ts">
import { useRoute } from 'vue-router';
import { i18n } from '@/i18n';

//i18n
const t = i18n.t;
const props = defineProps<{
  nowView: 'aggregateBusiness' | 'business';
}>();
</script>
<template>
  <div class="tab__container">
    <button
      :class="props.nowView === 'aggregateBusiness' ? 'tab__active' : 'tab__inactive'"
      @click="(e) => $emit('click', 'aggregateBusiness')"
    >
      {{ t('仕入取引') }}
    </button>
    <button :class="props.nowView === 'business' ? 'tab__active' : 'tab__inactive'" @click="(e) => $emit('click', 'business')">
      {{ t('販売取引') }}
    </button>
  </div>
</template>

<style lang="scss" scoped>
.tab {
  &__container {
    display: grid;
    grid-template-columns: auto auto auto;
    grid-gap: 10px;
    height: 30px;
  }

  &__active {
    color: $textDefault;
    height: 30px;
    border-bottom: 2px solid $semanticPrimary;
    text-align: center;
    line-height: 36px;
    font-family: Noto Sans JP;
    font-size: $fontSizeS;
    font-weight: 700;
    letter-spacing: 0em;
  }

  &__inactive {
    color: $textSecondary;
    height: 30px;
    text-align: center;
    line-height: 36px;
    font-family: Noto Sans JP;
    font-size: $fontSizeS;
    font-weight: 500;
    letter-spacing: 0em;
  }
}
</style>
